import { MULTI_PARTY as workflowTypeMP, workflowTypeDisplay } from './WorkflowTypes';

export const SINGLE_PARTY = "SINGLE_PARTY"
export const MULTI_PARTY = "MULTI_PARTY"
export const MULTIPARTY_CLAIMANT_CLAIMANT = "MULTIPARTY_CLAIMANT_CLAIMANT"
export const MULTIPARTY_CLAIMANT_PROVIDER = "MULTIPARTY_CLAIMANT_PROVIDER"
export const MULTIPARTY_COOWNER_PROVIDER = "MULTIPARTY_COOWNER_PROVIDER"
export const LIENHOLDER = "LIENHOLDER"
export const SINGLEPARTY_LIENHOLDER = "SINGLEPARTY_LIENHOLDER"
export const MULTIPARTY_LIENHOLDER = "MULTIPARTY_LIENHOLDER"
export const UNDEFINED_VENDOR = "UNDEFINED_VENDOR"

export const CLAIMANT_VENDOR_PAYMENTTYPES = ["MPCP", "MPCOP"];
export const MULTI_PARTY_PAYMENTTYPES = ["MPCC", "MPCP", "MPCOP"];
export const MULTIPLE_CLAIMANTS_PAYMENTTYPES = ["MPCC"];

export const paymentTypes = [
    SINGLE_PARTY,
	MULTIPARTY_CLAIMANT_CLAIMANT,
	MULTIPARTY_CLAIMANT_PROVIDER,
	MULTIPARTY_COOWNER_PROVIDER,
	SINGLEPARTY_LIENHOLDER,
	MULTIPARTY_LIENHOLDER,
	UNDEFINED_VENDOR
]

export const multiPartyPaymentTypes = [
    MULTIPARTY_CLAIMANT_CLAIMANT,
	MULTIPARTY_CLAIMANT_PROVIDER,
	MULTIPARTY_COOWNER_PROVIDER,
	MULTIPARTY_LIENHOLDER
]

export const lienholderPaymentTypes = [
	SINGLEPARTY_LIENHOLDER,
	MULTIPARTY_LIENHOLDER
]

export function paymentDisplayType(paymentType, workflowType) {
	if(workflowType === workflowTypeMP){
		return paymentTypeDisplay[paymentType]
	} else {
		return workflowTypeDisplay[workflowType]
	}
};

export const paymentTypeDisplay = {
	'SP': 'Individual',
	'MPCC': 'Multiple Claimants',
	'MPCP': 'Claimant & Vendor',
	'MPCOP': 'Co-Owner & Vendor',
	'SPLH': 'Lienholder',
	'MPLH': 'Lienholder',
	'UV': 'Vendor',
};
